import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Timestamp from "apps/messenger/components/MainWindow/MessagePane/Timestamp";
import ProfileLinkRequest from "apps/messenger/containers/ProfileLinkRequest";
import ProfileComment from "shared/components/ProfileComment";
import Str from "shared/components/Str";

import "apps/messenger/components/MainWindow/MessagePane/Message.scss";

const Message = ({
	timestamp,
	from,
	conversationUserId,
	body,
	profileComment,
	profileLinkRequest,
	showTimestamp,
	showReadIndicator,
}) => {
	// Is it incoming or outgoing?
	const direction = from === conversationUserId
		? "incoming"
		: "outgoing";

	const messageClasses = classnames(
		"messenger-message",
		`messenger-message--${direction}`,
	);

	return (
		<React.Fragment>
			<div className={messageClasses}>
				{showTimestamp && <Timestamp timestamp={timestamp} />}
				{profileComment && (
					<ProfileComment className="messenger-message-comment" {...profileComment} />
				)}
				{body && (
					<div className="messenger-message-bubble" dangerouslySetInnerHTML={{ __html: body }} />
				)}
				{showReadIndicator && (
					<div className="messenger-message-read-indicator">
						<span className="okicon i-checkmark" />
						<Str>Read</Str>
					</div>
				)}
			</div>
			{profileLinkRequest && (
				<ProfileLinkRequest {...profileLinkRequest} timestamp={timestamp} />
			)}
		</React.Fragment>
	);
};

Message.propTypes = {
	conversationUserId: PropTypes.string.isRequired,
	from: PropTypes.string.isRequired,

	timestamp: PropTypes.number.isRequired,
	body: PropTypes.string.isRequired,
	profileComment: PropTypes.object,
	profileLinkRequest: PropTypes.object,

	showReadIndicator: PropTypes.bool.isRequired,
	showTimestamp: PropTypes.bool.isRequired,
};

Message.defaultProps = {
	profileComment: null,
	profileLinkRequest: null,
};

export default Message;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/MessagePane/Message.jsx